import { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { MAX_GROUP_MEMBERS, INVITATION_EXPIRE_DAYS } from "@lib/store/src/data/groups/constants";

import { animated, config, useTransition } from "@react-spring/web";

import { Subtitle } from "@quarks";

export const GroupMemberSelectorEmptyState = ({
  searchCriteria,
  updatingSearchCriteria,
  selectionCount,
  resultCount,
  searchTerm,
}: HTMLAttributes<HTMLDivElement> & {
  searchCriteria: string;
  updatingSearchCriteria: boolean;
  selectionCount: number;
  resultCount: number;
  searchTerm: string;
}) => {
  const { t } = useTranslation("groups");
  const show: boolean = searchTerm.length > 0 && searchCriteria.length >= 1;
  const transition = useTransition(show, {
    initial: { opacity: 1, transform: "translate3d(0, 0px, 0) scale(1)", transformOrigin: "top center" },
    from: { opacity: 0, transform: "translate3d(0, 10px, 0) scale(1)", transformOrigin: "top center" },
    enter: { opacity: 1, transform: "translate3d(0, 0px, 0) scale(1)", transformOrigin: "top center" },
    leave: { opacity: 0, transform: "translate3d(0, 10px, 0) scale(1)", transformOrigin: "top center" },
    config: config.stiff,
  });

  return transition(
    (style, item) =>
      item && (
        <animated.div style={style}>
          {(() => {
            // Initial state - no search term and no group members
            if (!searchCriteria && !selectionCount) {
              return <Subtitle>{t("GroupMemberSearchInitialMessage", { number: INVITATION_EXPIRE_DAYS })}</Subtitle>;
            }

            // Too many group members
            if (selectionCount >= MAX_GROUP_MEMBERS && searchCriteria) {
              return (
                <Subtitle className="text-functional-red">
                  {t("InvalidNumberOfGroupMembersMessage", { number: MAX_GROUP_MEMBERS })}
                </Subtitle>
              );
            }

            // Still searching or no search term
            if (searchCriteria && !updatingSearchCriteria && resultCount === 0) {
              return <Subtitle>{t("GroupMembersNoUserFound")}</Subtitle>;
            }

            // Default case - no special state
            return null;
          })()}
        </animated.div>
      ),
  );
};
